import { gql } from '@apollo/client';

export default gql`
  query searchVouchers($email: String!) {
    searchVouchers(email: $email) {
      reference
      alias
      type
      status
      balance
      currency
      validUntil
      salesPeriodEnd
      createdBy
      createdAt
      description
      value
    }
  }
`;
